export const redirectUrl =
  "https://meetings.hubspot.com/honeypotz/honeypotz-meetings";
